import React from "react";
import { Button } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";

class AppMainButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() { }
  propButtonWidth() {
    return this.props.buttonWidth;
  }

  propButtonWidth() {
    return this.props.buttonWidth;
  }

  stateIsWithArrow() {
    return !this.props.isWithoutArrow;
  }

  getStyles() {
    let style = {
      backgroundColor: "#183028",
      color: "#FFFFFF",
      // borderRadius: "12px",
      height: "48px",
      width: '171px',
      fontSize: "14px",
      fontWeight: '600',
      // paddingLeft: "30px",
      // paddingRight: "30px",
      border: "1px solid transparent",
      width: this.propButtonWidth() || "171px",
      opacity: '50%'
    };

    if (this.props.enable) {
      style = {
        backgroundColor: "#183028",
        color: "#FFFFFF",
        height: '48px',
        width: '171px',
        fontSize: "14px",
        fontWeight: '600',
        // paddingLeft: "30px",
        // paddingRight: "30px",
        border: "0px solid transparent",
        // width: this.propButtonWidth() || "",
      };
    }

    return style;
  }

  getIconLeftArrowOnStatus() {
    let icon =
      GeneralBloc.getAssetsContextPath() +
      `/assets/icons/ArrowRight_Disable.png`;
    if (this.props.enable) {
      icon =
        GeneralBloc.getAssetsContextPath() + `/assets/icons/LeftArrowWhite.svg`;
    }
    return icon;
  }

  render() {
    return (
      <Button onClick={(e) => this.props.onClick(e)} style={this.getStyles()} disabled={!this.props.enable}>
        {this.props.label}
        {/* {this.props.icon && (
          <span className="ml-2">
            {this.stateIsWithArrow() ? (
              <img
                src={this.getIconLeftArrowOnStatus()}
                alt="New"
                className="mr-2"
              />
            ) : null}
          </span>
        )} */}
      </Button>
    );
  }
}

export default AppMainButton;
